export const getQueryParam = (param, location) => {
    var rx = new RegExp('[?&]' + param + '=([^&]+).*$');
    var returnVal = location.search.match(rx);
    return returnVal === null ? '' : returnVal[1];
};
